import { render, staticRenderFns } from "./CustomerServicePoint.vue?vue&type=template&id=496b74bc&"
import script from "./CustomerServicePoint.vue?vue&type=script&lang=js&"
export * from "./CustomerServicePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports